import { format, subDays, startOfYear } from "date-fns";

const gbpFmt = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" });
const gbpShort = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", notation: "compact", maximumFractionDigits: 1 });

export const gbp = (v) => gbpFmt.format(v || 0);
export const gbpK = (v) => gbpShort.format(v || 0);
export const num = (v) => new Intl.NumberFormat("en-GB").format(v || 0);
export const fmtDate = (d) => (d ? format(new Date(d), "dd MMM yyyy") : "—");
export const fmtDateTime = (d) => (d ? format(new Date(d), "dd MMM yyyy, HH:mm") : "—");

const iso = (d) => format(d, "yyyy-MM-dd");

export const PRESETS = [
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "12m", label: "Last 12 months" },
  { value: "ytd", label: "Year to date" },
  { value: "all", label: "All time" },
  { value: "custom", label: "Custom range" },
];

export const presetRange = (p) => {
  const today = new Date();
  if (p === "30d") return { date_from: iso(subDays(today, 30)), date_to: iso(today) };
  if (p === "90d") return { date_from: iso(subDays(today, 90)), date_to: iso(today) };
  if (p === "12m") return { date_from: iso(subDays(today, 365)), date_to: iso(today) };
  if (p === "ytd") return { date_from: iso(startOfYear(today)), date_to: iso(today) };
  return { date_from: "", date_to: "" };
};

export const makeFilters = (preset = "12m", extra = {}) => ({
  preset, ...presetRange(preset), region: "all", store: "all", concession: "all",
  status: "all", category: "all", source: "all", search: "", sap_code: "all", ...extra,
});

export const toParams = (f) => {
  const out = {};
  Object.entries(f).forEach(([k, v]) => {
    if (k !== "preset" && v && v !== "all") out[k] = v;
  });
  return out;
};

export const STATUS_META = {
  pending_approval: { label: "Pending approval", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-700 border-red-200" },
  dispatched: { label: "Dispatched", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  delivered: { label: "Delivered", cls: "bg-slate-100 text-slate-700 border-slate-200" },
};
